import { BrandsContainer, BrandItem } from "./styles";
import {
  SiSamsung,
  SiApple,
  SiXiaomi,
  SiMotorola,
  SiHuawei,
  SiAsus,
  SiGoogle,
  SiSony,
} from "react-icons/si";

const Brands = () => {
  return (
    <BrandsContainer>
      <p>Parceiros oficiais das principais marcas do mercado</p>
      <div className="brands-grid">
        <BrandItem>
          <SiSamsung style={{ color: "#1428A0" }} />
        </BrandItem>
        <BrandItem>
          <SiApple style={{ color: "#000000" }} />
        </BrandItem>
        <BrandItem>
          <SiXiaomi style={{ color: "#FF6700" }} />
        </BrandItem>
        <BrandItem>
          <SiMotorola style={{ color: "#E1140A" }} />
        </BrandItem>
        <BrandItem>
          <SiHuawei style={{ color: "#C7000B" }} />
        </BrandItem>
        <BrandItem>
          <SiAsus style={{ color: "#000000" }} />
        </BrandItem>
        <BrandItem>
          <SiGoogle style={{ color: "#4285F4" }} />
        </BrandItem>
        <BrandItem>
          <SiSony style={{ color: "#000000" }} />
        </BrandItem>
      </div>
    </BrandsContainer>
  );
};

export default Brands;
